import {Helmet} from 'react-helmet';
import AboutUs from "../../Page/aboutus";
import Testimonials from "../../Page/testimonials";
import Certificate from "../../Page/Certificate";

const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What services does a website developer provide?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A website developer designs, builds, and maintains websites by writing code, integrating features, and ensuring the site functions smoothly across devices."
      }
    },
    {
      "@type": "Question",
      "name": "Why should I hire a professional website developer?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Hiring a professional ensures your website is well-designed, SEO-friendly, secure, and tailored to your business needs, saving you time and hassle."
      }
    },
    {
      "@type": "Question",
      "name": "What technologies do you use for website development?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I work with HTML, CSS, JavaScript, PHP, WordPress, React, Node.js, and Laravel to create modern, responsive, and SEO-optimized websites."
      }
    },
    {
      "@type": "Question",
      "name": "How much does it cost to hire a website developer?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Costs vary depending on project complexity. Basic websites start from ₹10,000, while advanced or e-commerce sites can cost ₹25,000 or more."
      }
    },
    {
      "@type": "Question",
      "name": "Can I update my website content after it is built?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, websites are usually built on CMS platforms like WordPress, allowing you to easily update content without coding skills."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer SEO services with website development?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I follow SEO best practices including on-page optimization, schema markup, fast loading speeds, and mobile responsiveness."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to develop a website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A basic website typically takes 5–7 days, while more complex or e-commerce projects may take 2–6 weeks."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide website maintenance and support?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I offer maintenance packages including updates, backups, bug fixes, and performance monitoring."
      }
    },
    {
      "@type": "Question",
      "name": "Will my website be mobile friendly?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. All websites are designed to be fully responsive and look great on all devices."
      }
    },
    {
      "@type": "Question",
      "name": "How do I get started with your website development services?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can contact me through my website or phone to discuss your project requirements and receive a custom quote."
      }
    }
  ]
}

function App1() {


  return (
   <>
 <Helmet>
  <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
    <title>Pankaj - Website Developer</title>
  <meta name="description" content="Need a skilled website developer? Our team of experts can create stunning websites tailored to your business needs, from e-commerce to portfolio sites."/>
  <meta name="keywords" content="pankaj, website developer, website designing company, web developer, website design, website maker, web design company in gurugram, web design gurugram, web designer gurugram, web development company in gurugram, website development agency gurgaon"/>
<meta property="og:title" content="Pankaj - Website Developer | website development company" />
<meta property="og:description" content="Need a skilled website developer? Our team of experts can create stunning websites tailored to your business needs, from e-commerce to portfolio sites." />
<meta property="og:site_name" content="Pankaj - Website Developer | website development company" />
<meta property="og:url" content="https://www.pankj.com/website-designer-in-gurgaon"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Pankaj - Website Developer | website development company" />
<meta name="twitter:description" content="Need a skilled website developer? Our team of experts can create stunning websites tailored to your business needs, from e-commerce to portfolio sites." />
<link rel="canonical" href="https://www.pankj.com/website-developer" />

        </Helmet>
 <section id="hero" className="hero d-flex align-items-center fixedabove">
<video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/pankaj-web-designer1.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg campaignpage">
<div className="container-fluid">
<div className="row">
<div className="col-lg-7 d-flex flex-column order-xs-2 order-xs-1">
<img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
<div className="multiple_effects fzsml" id="text3d"><span className="offers"></span></div>
<div className="content_sec" data-aos="fade-up" data-aos-delay="400">If you are looking for a <h1 className="headerdesign">Website Developer</h1>, then you are in the right place. Hello, I am pankaj with 10+ years of experience in website design & development. you can hire me as a freelancer for your dream projects.</div>
         <form action="https://www.pankj.com/php/campaign.php" method="post" className="php-email-form">
          <div className="claimnow"><i className="bi bi-gift"></i>&nbsp; Get a Website Today<strike>
       <i className="bi bi-currency-rupee"></i>10,000
    </strike> (<i className="bi bi-currency-rupee"></i>2,100 Only )<sup className="tcst"> T&C Apply*</sup></div>
              <div className="row gy-4">
                <div className="col-md-4 col-7">
                <input type="text" className="hiddenclasss" name="title" />
                  <input type="text" name="name" minLength="2" maxLength="20" id="name" className="form-control" placeholder="Your Name" required />
                </div>
                  <div className="col-md-3 col-5">
                  <input type="number" className="form-control" minLength="10" maxLength="13" name="phone" id="phone" placeholder="Your Phone" required />
                </div>
                <div className="col-md-5 col-sm-12 text-center mtss">
                  <input type="submit" className="form-control submitbtn" name="submit" placeholder="Submit" value="Claim Now(₹2100)Only*" onclick="return SubmitDetails();" />
                </div>

              </div>
            </form>
</div>
<div className="col-lg-5 hero-img order-xs-1 order-md-2" data-aos="zoom-out" data-aos-delay="200">
<div className="wrapper">
<div className="img-area">
<div className="inner-area">
<div className="bgimg"></div>
</div>
</div>

</div>
</div>

</div>
</div> 

</div>
</section> 

    <main id="main">
 <AboutUs />
<Testimonials/>
<Certificate />
</main>
    </>
  );
}
export default App1;
